#import "../../email-marketing/graphql/fragments/em-from-address-fragment.graphql"

query GetVerifiedEmailAddresses($userId: String) {
    fromAddresses(first: 100, userId: $userId) {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
        }
        edges {
            cursor
            node {
                ...FromAddress
            }
        }
    }
}
